import React, { useState } from 'react';
import { Award, FileCheck, X, AlertCircle } from 'lucide-react';
import { certificates } from '../data/mock';

const Certifications = () => {
  const [selectedCert, setSelectedCert] = useState(null);
  const [showWarning, setShowWarning] = useState(false);

  const openCertificate = (cert) => {
    if (cert.placeholder) {
      return;
    }
    setSelectedCert(cert);
    setShowWarning(true);
    setTimeout(() => setShowWarning(false), 3000);
  };

  const closeCertificate = () => {
    setSelectedCert(null);
    setShowWarning(false);
  };

  const preventContextMenu = (e) => {
    e.preventDefault();
    return false;
  };

  return (
    <section id="certifications" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center mb-4">
              <Award className="text-blue-600" size={36} />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Certifications & Accreditations
            </h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              Our commitment to quality and compliance is reflected in our certifications
            </p>
            <div className="w-24 h-1 bg-blue-600 mx-auto mt-4"></div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6">
            {certificates.map((cert) => (
              <div
                key={cert.id}
                onClick={() => openCertificate(cert)}
                className={`bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 group ${
                  cert.placeholder ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:-translate-y-2'
                }`}
              >
                <div className="flex flex-col items-center text-center h-full">
                  <div className="bg-blue-600 w-16 h-16 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                    {cert.placeholder ? (
                      <FileCheck className="text-white" size={32} />
                    ) : (
                      <Award className="text-white" size={32} />
                    )}
                  </div>
                  <h3 className="text-sm font-bold text-gray-900 mb-2 line-clamp-2">{cert.name}</h3>
                  <p className="text-xs text-blue-600 font-medium">{cert.type}</p>
                  {cert.placeholder && (
                    <p className="text-xs text-gray-500 mt-2">Coming Soon</p>
                  )}
                  {!cert.placeholder && (
                    <p className="text-xs text-gray-600 mt-2">Click to View</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {selectedCert && (
        <div className="fixed inset-0 z-50 bg-black/95 flex flex-col">
          <div className="bg-gray-900 px-6 py-4 flex items-center justify-between">
            <div>
              <h3 className="text-white font-bold text-lg">{selectedCert.name}</h3>
              <p className="text-gray-400 text-sm">{selectedCert.type}</p>
            </div>
            <button
              onClick={closeCertificate}
              className="text-white hover:text-gray-300 transition-colors p-2"
            >
              <X size={28} />
            </button>
          </div>

          {showWarning && (
            <div className="bg-amber-600 text-white px-6 py-3 flex items-center space-x-3 animate-fade-in">
              <AlertCircle size={20} />
              <span className="text-sm font-medium">
                This certificate is protected. Right-click, download, and print functions are disabled.
              </span>
            </div>
          )}

          <div className="flex-1 relative" onContextMenu={preventContextMenu}>
            <div className="absolute inset-0 z-10 pointer-events-none"></div>
            
            <iframe
              src={`${selectedCert.url}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
              className="w-full h-full border-0"
              title={selectedCert.name}
              onContextMenu={preventContextMenu}
            />

            <div className="absolute inset-0 pointer-events-none flex items-center justify-center z-20">
              <div className="text-gray-500/10 text-6xl font-bold transform rotate-[-45deg] select-none">
                WWMS CONFIDENTIAL
              </div>
            </div>
          </div>

          <div className="bg-gray-900 px-6 py-3 text-center">
            <p className="text-gray-400 text-sm">
              Press ESC or click the X button to close | This document is protected and cannot be downloaded
            </p>
          </div>
        </div>
      )}
    </section>
  );
};

export default Certifications;